import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/core-js/modules/es6.array.iterator.js";
import "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/core-js/modules/es6.promise.js";
import "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/core-js/modules/es6.object.assign.js";
import "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/core-js/modules/es7.promise.finally.js";
import "./util/themeColor";
import reportData from "./util/reportData";
import "./setting";
import Vue from 'vue';
import App from "./index.vue";
import setup, { store } from '@tencent/vft-vue-base';
import bumpModule from "./store/bump";
import '@/configs/plugins';
import '@/configs/mixin';

_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return setup({
            storeOptions: {
              modules: {
                bump: bumpModule
              }
            },
            reportOptions: {
              pageType: 'activity',
              reportData: reportData
            }
          });

        case 3:
          _context.next = 5;
          return store.dispatch('init');

        case 5:
          _context.next = 12;
          break;

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          alert('很抱歉！页面初始化失败，请刷新重试，如仍有问题，请联系客服！');
          console.error(_context.t0);
          throw _context.t0;

        case 12:
          _context.prev = 12;
          new Vue({
            store: store,
            render: function render(h) {
              return h(App);
            }
          }).$mount('#app');
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t1 = _context["catch"](12);
          console.error(_context.t1);
          throw _context.t1;

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[0, 7], [12, 16]]);
}))();